import { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight, Quote } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { TESTIMONIALS } from "@/data/content";
import { useT } from "@/i18n";

export default function Testimonials() {
  const t = useT();
  const [i, setI] = useState(0);
  const total = TESTIMONIALS.length;

  useEffect(() => {
    const tt = setInterval(() => setI((v) => (v + 1) % total), 8000);
    return () => clearInterval(tt);
  }, [total]);

  const prev = () => setI((v) => (v - 1 + total) % total);
  const next = () => setI((v) => (v + 1) % total);

  const item = TESTIMONIALS[i];

  return (
    <section className="bg-white py-24 md:py-32" data-testid="testimonials">
      <div className="max-w-[1100px] mx-auto px-6 md:px-10 text-center">
        <Reveal>
          <Quote size={56} className="text-[#C20E1A] mx-auto" strokeWidth={1.2} />
        </Reveal>
        <div className="mt-10 min-h-[260px]">
          <p
            key={i}
            className="text-xl sm:text-2xl lg:text-3xl text-black/85 leading-relaxed italic font-light animate-[fadeIn_700ms_ease]"
          >
            {item.quote}
          </p>
          <div className="mt-10">
            <p className="text-[12px] uppercase tracking-[0.3em] font-bold text-black">
              — {item.name}
            </p>
            <p className="mt-2 text-sm text-black/55">{t.testimonials.visitorLabel} · {item.place}</p>
          </div>
        </div>
        <div className="mt-12 flex items-center justify-center gap-3">
          <button data-testid="testimonial-prev" className="nav-arrow" onClick={prev} aria-label="Previous">
            <ArrowLeft size={18} />
          </button>
          <div className="flex items-center gap-2 mx-4">
            {TESTIMONIALS.map((_, j) => (
              <button
                key={j}
                data-testid={`testimonial-dot-${j}`}
                onClick={() => setI(j)}
                className={`h-[2px] transition-all ${
                  j === i ? "w-10 bg-[#C20E1A]" : "w-5 bg-black/20 hover:bg-black/50"
                }`}
                aria-label={`Show review ${j + 1}`}
              />
            ))}
          </div>
          <button data-testid="testimonial-next" className="nav-arrow" onClick={next} aria-label="Next">
            <ArrowRight size={18} />
          </button>
        </div>
      </div>

      <style>{`@keyframes fadeIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}`}</style>
    </section>
  );
}
